import React from 'react'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL, BACK_URL } from './URLConstants';
import { BrowserRouter, Routes, Route, Link, HashRouter } from 'react-router-dom';
import { fetchDetails, scrollToTop } from './Api';

export default function Thematicpage(props) {

    const styles = {
        backgroundColor: props.color,
        // fontSize: props.fontSize,
        // fontWeight: props.bold ? 'bold' : 'normal'
    };

    let i = 1;

    const [pillars, setpillars] = useState([])  //Day1 Hall1

    useEffect(() => {
        const fetchData = async () => {
            const url = `${API_URL}/pillars`;
            const data = await fetchDetails(url);
            if (data) {
                setpillars(data);
            }
            scrollToTop();
        };

        fetchData();
    }, []);





    return (
        <section id="thematic" className="tg-sectionspace tg-haslayout" style={styles}>
            <div className="container">
                <div className="row">
                    {/* <div
                                className="col-xs-offset-0 col-xs-12 col-sm-offset-0 col-sm-12 col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8"> */}
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="tg-sectionhead  tg-textalignleft">
                            <div className="tg-sectionheading">

                                <h2>Thematic Focus </h2>
                            </div>
                            <div className="tg-description">
                                <p>The ICDRI 2023 will bring to fore demonstrated practices and solutions, delving into systems, practices, and finances, that enable provisioning of resilient infrastructure to people and economies across different geographies, climate typologies and infrastructure sectors. </p>
                            </div>
                        </div>
                    </div>
                    <div className="tg-packages">
                        {pillars.map(pillar => (
                            <div key={pillar.id} className="col-md-4">
                                <div className="tg-package tg-basicplan">


                                    <Link to={`/pagedetail/${pillar.id}`}><div className="tg-packagehead first">
                                        <figure className="tg-themepostimg">
                                            <img src={`${BACK_URL}/${pillar.image}`} alt="" />
                                            <figcaption className="tg-packagedetail">
                                                <h3 className="head">Pillar {i++}:<br />
                                                    {pillar.title}</h3>


                                            </figcaption>
                                        </figure>
                                    </div>
                                    </Link>

                                </div>
                            </div>
                        ))}
                        {/* <a href="#"><div className="col-md-4">
                            <div className="tg-package tg-corporateplan">
                                <div className="tg-packagehead">
                                    <figure className="tg-themepostimg">
                                        <img src="images/packages/Pillar2.gif" alt="" />
                                        <figcaption className="tg-packagedetail">
                                            <h3 className="head">Pillar 2:<br /> Delivering Resilient Infrastructure – Providing Reliable Services through Resilient
                                                Infrastructure Assets</h3>

                                        </figcaption>
                                    </figure>
                                </div>

                            </div>
                        </div></a>
                        <a href="#"><div className="col-md-4">
                            <div className="tg-package tg-businessplan">
                                <div className="tg-packagehead">
                                    <figure className="tg-themepostimg">
                                        <img src="images/packages/Pillar3.gif" alt="" />
                                        <figcaption className="tg-packagedetail">
                                            <h3 className="head">Pillar 3:<br /> Delivering Resilient Infrastructure – Realising Finance and Investments for Infrastructure Resilience</h3>

                                        </figcaption>
                                    </figure>
                                </div>

                            </div>
                        </div></a> */}

                    </div >
                </div >
            </div >
        </section >
    )
}
